exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-d8ab45f4]{text-align:center}.content img[data-v-d8ab45f4]{height:auto;width:1.32rem;margin:1.4rem 0 .34rem}.content p[data-v-d8ab45f4]{font-size:.28rem;color:#19191a;width:80%;margin-left:10%;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8ab45f4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/appointed-road-test/components/NotAvailable.vue
// module id = 32wZ
// module chunks = 1